import _ from 'lodash';

import { Waiver } from '../../../../types/waiver';
import { Action } from '../../../types';
import { types } from './waiversActions';

export type WaiverState = {
  waiversById: { [key: number]: Waiver | null },
  loading: boolean,
  error?: string,
};

const initialState: WaiverState = {
  waiversById: {},
  loading: false,
};

export default function(
  state: WaiverState = initialState,
  action: Action<any>,
): WaiverState {
  switch (action.type) {
    case types.FETCH_WAIVERS:
      return {
        ...state,
        loading: true,
      };
    case types.FETCH_WAIVERS_SUCCESS:
      return {
        ...state,
        loading: false,
        waiversById: _.keyBy(action.response, 'id') || {},
      };
    case types.UPDATE_CHANGE_EVENT_ID_SUCCESS:
      if (!action.response) {
        return state;
      }

      return {
        ...state,
        waiversById: {
          ...state.waiversById,
          [action.response.id]: action.response,
        },
      };
    default:
      return state;
  }
}
